var Product = Backbone.Model.extend({
    defaults: {
        'post_id': 0,
        'visible' : true,
        'name' : '',
        'link' : '#',
        'price': '0',
        'order' : '0',
        'image' : 'https://placehold.co/310x310?text=Placeholder&font=lato',
        'filter' : null,
        'filters': {},
        'type_variations' : {},
        'view_props' : {},
        'downloads' : []
    },
    initialize: function( options ){
        this.filter = typeof options.filter !== 'undefined' ? options.filter : null;
        _.bindAll( this, 'updateViewProps', 'dummyDownloads' );
        let filters = this.get( 'filters' );
        this.set({ 'filters' : JSON.parse( filters ) });
        // let type_variations = this.get( 'type_variations' );
        //this.set({ 'type_variations' : JSON.parse( type_variations ) });
        let downloads = this.get( 'downloads' );
        this.set({ 'downloads' : JSON.parse( downloads ) });
        // this.dummyDownloads();
    },
    dummyDownloads: function(){
        var downloads = [];
        downloads.push( { 'name' : 'CAD', 'link' : '#' } );
        downloads.push( { 'name' : 'Revit', 'link' : '#' } );
        downloads.push( { 'name' : 'SketchUp', 'link' : '#' } );
        this.set( {'downloads' : downloads } );
    },
    updateViewProps: function( filter_settings ){
        var type_variations = this.get( 'type_variations' );
        var props = [ 'product_seating_type', 'product_tables_type' ];
        var x = {};
        for ( var i = 0; i < props.length; i++ ) {
            var key = props[i];
            var selectedType = filter_settings[key] !== 'undefined' ? filter_settings[key] : null;

            if ( _.isEmpty( selectedType ) ) {
                continue;
            }

            if ( typeof type_variations[selectedType] !== 'undefined' ) {
                var variation = type_variations[selectedType];
                x.image = variation.image;
                x.name = variation.name;
                x.price = variation.price;
                break;
            }
        }
        x.image = _.isEmpty( x.image ) ? this.get('image') : x.image;
        x.name = _.isEmpty( x.name ) ? this.get('name') : x.name;
        x.price = _.isEmpty( x.price ) ? this.get('price') : x.price;
        
        this.set({ 'view_props' : x });
    }
});
export {Product};